module.exports = __webpack_public_path__ + "img/cnu_new_logo.a9576c80.png";